import React from "react";

function CollectionDetails() {
  return (
    <>
      {" "}
      <div className="terms">
        <div className="terms__wrapper">
          <div className="d-flex">
            <p>Items</p>
            <h5 className="neutral-bottom mx-2">888</h5>
          </div>
          <div className="d-flex">
            <p>Chain</p>
            <h5 className="neutral-bottom mx-2">Ethereum</h5>
          </div>
          <div className="d-flex">
            <p>Creator fee</p>
            <h5 className="neutral-bottom mx-2">3.5% </h5>
          </div>
          <div className="d-flex">
            <p> Created</p>
            <h5 className="neutral-bottom mx-2">Dec 2022 </h5>
          </div>
        </div>
      </div>
      <div className="group__one">
        <h4>Description</h4>
        <p>
          Some may regard this as the supreme sea view home, the perfect place
          for modern living, or even the best of all worlds… but here, you can
          simply call it Mezzo.
          <br />
          <br />
          Conceptualised with the multi-faceted lifestyles of today’s modern
          elites in mind, Mezzo is envisioned as the ultimate home for those who
          seek not only luxury and exclusivity but also an exciting lifestyle
          and modern experiences that extend well beyond the confines of the
          residence itself.
        </p>
      </div>
      <div className="terms">
        <div className="terms__wrapper">
          <div className="d-flex flex-column-reverse align-items-center">
            <p>Property Type</p>
            <h5 className="neutral-bottom mx-2">Comercial</h5>
          </div>
          <div className="d-flex flex-column-reverse align-items-center">
            <p>Tenure</p>
            <h5 className="neutral-bottom mx-2">5 Years</h5>
          </div>
          <div className="d-flex flex-column-reverse align-items-center">
            <p>Total Units</p>
            <h5 className="neutral-bottom mx-2">120</h5>
          </div>
          <div className="d-flex flex-column-reverse align-items-center">
            <p>Completion Year</p>
            <h5 className="neutral-bottom mx-2">2024</h5>
          </div>
          {/* <div className="d-flex flex-column-reverse align-items-center">
            <p>owners</p>
            <h5 className="neutral-bottom mx-2">483</h5>
          </div>
          <div className="d-flex flex-column-reverse align-items-center">
            <p>unique owners</p>
            <h5 className="neutral-bottom mx-2">53%</h5>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default CollectionDetails;
